import { useAppSelector } from '@/app/hooks';
import getNavData from './nav-data';
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

export const HeaderNav = () => {
  const { isAuthenticated, cabinetType } = useAppSelector(
    (state) => state.auth
  );
  const { palette } = useTheme();
  const navData = getNavData();
  const { pathname } = useLocation();

  const isMobile = useMediaQuery('(max-width: 960px)');

  if (isMobile) return null;

  return (
    <Stack
      component='nav'
      direction='row'
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      {navData
        .filter(
          (el) =>
            !el.condition ||
            el.condition({
              isAuthenticated,
              cabinetType,
              pathname,
            })
        )
        .map((el, idx) => {
          if (!el.isLanding && pathname === '/') return null;
          if (el.isLanding && pathname !== '/') return null;

          const isActive = pathname.includes(el.to);
          const isAnchor = el.to.startsWith('#');

          return (
            <Box
              {...(isAnchor
                ? {
                    component: 'a',
                    href: el.to,
                  }
                : {
                    component: Link,
                    to: el.to,
                  })}
              key={idx}
              sx={{
                textDecoration: 'none !important',
                cursor: 'pointer',
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  bgcolor: isActive ? 'rgba(21, 85, 252, 0.04)' : 'none',
                  borderRadius: '6px',
                  borderBottom: isActive
                    ? '1px solid rgba(21, 85, 252, 0.2)'
                    : 'none',
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1,
                    color: isActive
                      ? palette.text.primary
                      : palette.primary['main'],
                  }}
                >
                  {el.label}
                </Typography>
              </Box>
            </Box>
          );
        })}
    </Stack>
  );
};
